// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"d7280222","139":"6c13bbef","273":"3eb60b00","512":"10ba9ca7","579":"922fbc15","582":"54d50a62","807":"f1240cdc","937":"d8b12129","995":"5cb3fe03"}[chunkId] + ".chunk.js";
};